module.exports = "/fonts/OpenSans-Bold.ttf";